AFRAME.registerComponent('news-graph-sources-vr', {
    init: function () {
        this.render = this.render.bind(this);
        this.titleText = 'Sources';
        this.articlesData = [];
        this.currentPage = 0;

        const parsed = window.getCacheItem ? window.getCacheItem('configureControlSettings') : {};
        this.themeMode = parsed && parsed.themeMode === 'Light' ? 'Light' : 'Dark';
        const mainSettings = window.getCacheItem ? window.getCacheItem('mainSettings') : null;
        if (mainSettings && (mainSettings.themeMode === 'Light' || mainSettings.themeMode === 'Dark')) {
            this.themeMode = mainSettings.themeMode;
        }
        this.textColor = this.themeMode === 'Light' ? '#111' : '#fff';

        this.render();

        this.onNodeClicked = this.onNodeClicked.bind(this);
        this.el.sceneEl.addEventListener('news-graph-node-clicked', this.onNodeClicked);
        this.el.sceneEl.addEventListener('theme-changed', (e) => {
            this.themeMode = e.detail?.themeMode || this.themeMode;
            this.textColor = this.themeMode === 'Light' ? '#111' : '#fff';
            this.render();
        });
    },

    remove: function () {
        this.el.sceneEl.removeEventListener('news-graph-node-clicked', this.onNodeClicked);
    },

    onNodeClicked: function(e) {
        const { node, data } = e.detail;
        const leftPanel2 = document.querySelector('#left-panel-2');
        
        if (!node || !data || !node.article_ids || node.article_ids.length === 0) {
            this.titleText = 'Sources (0)';
            this.articlesData = [];
            this.currentPage = 0;
            this.render();
            
            this.el.setAttribute('visible', 'false');
            this.el.setAttribute('position', '0 6 0');
            if (leftPanel2) {
                const s1 = leftPanel2.querySelector('#news-screen-1');
                const s2 = leftPanel2.querySelector('#news-screen-2');
                if (s1) {
                    s1.setAttribute('visible', 'true');
                    s1.setAttribute('position', '0 0 0.02');
                }
                if (s2) {
                    s2.setAttribute('visible', 'false');
                    s2.setAttribute('position', '0 6 0');
                }
            }
            return;
        }

        const articlesMap = data.articles || {};
        this.articlesData = node.article_ids.map(id => articlesMap[id]).filter(Boolean);
        this.titleText = `Sources (${this.articlesData.length})`;
        this.currentPage = 0;
        this.graphData = data;
        
        this.render();

        this.el.setAttribute('visible', 'true');
        this.el.setAttribute('position', '0 0.01 0.05');
        if (leftPanel2) {
            const s1 = leftPanel2.querySelector('#news-screen-1');
            const s2 = leftPanel2.querySelector('#news-screen-2');
            if (s1) {
                s1.setAttribute('visible', 'false');
                s1.setAttribute('position', '0 6 0');
            }
            if (s2) {
                s2.setAttribute('visible', 'false');
                s2.setAttribute('position', '0 6 0');
            }
        }
    },

    render: function() {
        this._hideArticleTooltip();
        while (this.el.firstChild) {
            this.el.removeChild(this.el.firstChild);
        }

        const header = document.createElement('a-troika-text');
        header.setAttribute('value', this.titleText);
        header.setAttribute('color', this.textColor);
        header.setAttribute('font-size', '0.06');
        header.setAttribute('position', '0 0.8 0.03');
        header.setAttribute('align', 'center');
        this.el.appendChild(header);

        if (this.articlesData && this.articlesData.length > 0) {
            const backBtn = document.createElement('a-entity');
            backBtn.setAttribute('ui-button', {
                type: 'rounded-box',
                image: '#back-button',
                width: 0.1,
                height: 0.1,
                depth: 0.01,
                radius: 0.02,
                colorScheme: 'primary'
            });
            backBtn.setAttribute('position', '-0.45 0.8 0.03');
            backBtn.setAttribute('class', 'clickable');
            backBtn.setAttribute('data-raycastable', '');
            backBtn.addEventListener('click', () => {
                this.el.setAttribute('visible', 'false');
                this.el.setAttribute('position', '0 6 0');
                
                const leftPanel2 = document.querySelector('#left-panel-2');
                if (leftPanel2) {
                    const s1 = leftPanel2.querySelector('#news-screen-1');
                    if (s1) {
                        s1.setAttribute('visible', 'true');
                        s1.setAttribute('position', '0 0 0.02');
                    }
                }
                
                const vizEl = document.querySelector('[news-graph-vr], [news-graph-2d-vr]');
                const component = vizEl && (vizEl.components['news-graph-vr'] || vizEl.components['news-graph-2d-vr']);
                if (component) {
                    component.setSelectedNodeEl(null, null, false);
                }

                this.el.sceneEl.emit('news-graph-node-clicked', { node: null, data: this.graphData });
            });
            this.el.appendChild(backBtn);
        }

        if (this.articlesData.length === 0) {
            const noData = document.createElement('a-troika-text');
            noData.setAttribute('value', 'Select a node to view sources');
            noData.setAttribute('color', '#888');
            noData.setAttribute('font-size', '0.04');
            noData.setAttribute('position', '0 0.5 0.03');
            noData.setAttribute('align', 'center');
            this.el.appendChild(noData);
            return;
        }

        let yPos = 0.5;
        const itemsPerPage = 5;
        const totalPages = Math.ceil(this.articlesData.length / itemsPerPage);
        
        const start = this.currentPage * itemsPerPage;
        const pageItems = this.articlesData.slice(start, start + itemsPerPage);
        
        for (let i = 0; i < pageItems.length; i++) {
            const article = pageItems[i];
            const sourceName = String(article.source || article.publisher || 'Unknown')
                .replace(/\s+/g, ' ')
                .trim();
            const titleStr = String(article.title || '')
                .replace(/\s+/g, ' ')
                .trim();
            const description = this._articleDescription(article);
            const url = article.url || '#';

            let dateStr = '';
            if (article.published_at) {
                try {
                    const d = new Date(article.published_at);
                    dateStr = d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
                } catch(e) {}
            }

            const itemWrapper = document.createElement('a-entity');
            itemWrapper.setAttribute('position', `0 ${yPos} 0.03`);
            this.el.appendChild(itemWrapper);

            // Item Background
            const bgEl = document.createElement('a-rounded-box');
            bgEl.setAttribute('width', 1.05);
            bgEl.setAttribute('height', 0.22);
            bgEl.setAttribute('depth', 0.005);
            bgEl.setAttribute('color', this.themeMode === 'Light' ? '#eee' : '#222');
            bgEl.setAttribute('radius', 0.015);
            bgEl.setAttribute('class', 'clickable');
            bgEl.setAttribute('data-raycastable', '');
            itemWrapper.appendChild(bgEl);

            const sourceText = document.createElement('a-troika-text');
            const compactSource = sourceName.length > 38 ? sourceName.slice(0, 37) + '…' : sourceName;
            sourceText.setAttribute('value', `${compactSource} • ${dateStr}`);
            sourceText.setAttribute('color', '#888');
            sourceText.setAttribute('font-size', '0.025');
            sourceText.setAttribute('position', '-0.48 0.06 0.01');
            sourceText.setAttribute('anchor', 'left');
            itemWrapper.appendChild(sourceText);

            const titleTextEl = document.createElement('a-troika-text');
            titleTextEl.setAttribute('value', titleStr.substring(0, 78) + (titleStr.length > 78 ? '…' : ''));
            titleTextEl.setAttribute('color', this.textColor);
            titleTextEl.setAttribute('font-size', '0.028');
            titleTextEl.setAttribute('line-height', '1.1');
            titleTextEl.setAttribute('position', '-0.48 0.025 0.01');
            titleTextEl.setAttribute('anchor', 'left');
            titleTextEl.setAttribute('baseline', 'top');
            titleTextEl.setAttribute('max-width', '0.72');
            itemWrapper.appendChild(titleTextEl);

            const btn = document.createElement('a-entity');
            btn.setAttribute('ui-button', {
                label: 'Open',
                width: 0.16,
                height: 0.06,
                depth: 0.01,
                radius: 0.01,
                colorScheme: 'primary',
                preferredFontSize: 0.03
            });
            btn.setAttribute('position', '0.38 -0.03 0.01');
            btn.setAttribute('class', 'clickable');
            btn.setAttribute('data-raycastable', '');
            btn.addEventListener('click', () => {
                window.open(url, '_blank');
            });
            itemWrapper.appendChild(btn);

            if (description) {
                // Capture the card's Y position at creation time so the tooltip
                // can be anchored precisely below the lower edge of this specific card.
                const cardY = yPos;
                const showDescription = () => this._showArticleTooltip(cardY, description);
                const hideDescription = () => this._hideArticleTooltip();
                bgEl.addEventListener('mouseenter', showDescription);
                bgEl.addEventListener('mouseleave', hideDescription);
                btn.addEventListener('mouseenter', showDescription);
                btn.addEventListener('mouseleave', hideDescription);
            }

            yPos -= 0.26;
        }

        if (totalPages > 1) {
            yPos -= 0.02;
            const paginationContainer = document.createElement('a-entity');
            paginationContainer.setAttribute('position', `0 ${yPos} 0.03`);
            
            const prevBtn = document.createElement('a-entity');
            prevBtn.setAttribute('ui-button', { label: '<', type: 'rounded-box', width: 0.12, height: 0.07, depth: 0.01, colorScheme: 'primary', radius: 0.01, preferredFontSize: 0.04 });
            prevBtn.setAttribute('position', `-0.18 0 0`);
            prevBtn.setAttribute('class', 'clickable');
            prevBtn.setAttribute('data-raycastable', '');
            prevBtn.addEventListener('click', () => {
                this.currentPage = (this.currentPage - 1 + totalPages) % totalPages;
                this.render();
            });
            paginationContainer.appendChild(prevBtn);

            const pageLabel = document.createElement('a-troika-text');
            pageLabel.setAttribute('value', `${this.currentPage + 1} / ${totalPages}`);
            pageLabel.setAttribute('font-size', '0.045');
            pageLabel.setAttribute('align', 'center');
            pageLabel.setAttribute('anchor', 'center');
            pageLabel.setAttribute('baseline', 'center');
            pageLabel.setAttribute('position', '0 0 0.005');
            pageLabel.setAttribute('color', this.textColor);
            paginationContainer.appendChild(pageLabel);

            const nextBtn = document.createElement('a-entity');
            nextBtn.setAttribute('ui-button', { label: '>', type: 'rounded-box', width: 0.12, height: 0.07, depth: 0.01, colorScheme: 'primary', radius: 0.01, preferredFontSize: 0.04 });
            nextBtn.setAttribute('position', `0.18 0 0`);
            nextBtn.setAttribute('class', 'clickable');
            nextBtn.setAttribute('data-raycastable', '');
            nextBtn.addEventListener('click', () => {
                this.currentPage = (this.currentPage + 1) % totalPages;
                this.render();
            });
            paginationContainer.appendChild(nextBtn);

            this.el.appendChild(paginationContainer);
        }
    },

    _plainText: function(value) {
        if (value === null || value === undefined) return '';
        const holder = document.createElement('div');
        let text = String(value);
        // Two passes also handle feeds that escaped their HTML before serializing it.
        for (let pass = 0; pass < 2; pass += 1) {
            holder.innerHTML = text;
            holder.querySelectorAll('script, style, noscript, iframe, svg').forEach(el => el.remove());
            text = String(holder.textContent || holder.innerText || '');
            if (!/<\/?[a-z][^>]*>/i.test(text)) break;
        }
        return text
            .replace(/\u00a0/g, ' ')
            .replace(/\s+/g, ' ')
            .trim();
    },

    _articleDescription: function(article) {
        const description = this._plainText(article?.description || article?.summary || article?.text || '');
        return description.length > 220 ? description.slice(0, 219).trimEnd() + '…' : description;
    },

    _showArticleTooltip: function(cardY, description) {
        this._hideArticleTooltip();
        const tooltip = document.createElement('a-entity');
        tooltip.setAttribute('id', 'news-graph-article-tooltip-vr');
        const tooltipY = cardY - 0.30;
        tooltip.setAttribute('position', `0 ${tooltipY} 0.12`);

        const bg = document.createElement('a-rounded-plane');
        bg.setAttribute('width', '1.00');
        bg.setAttribute('height', '0.36');
        bg.setAttribute('radius', '0.015');
        bg.setAttribute('color', this.themeMode === 'Light' ? '#f8fafc' : '#111827');
        bg.setAttribute('opacity', '0.98');
        bg.setAttribute('position', '-0.5 -0.18 0');
        tooltip.appendChild(bg);

        const text = document.createElement('a-troika-text');
        text.setAttribute('value', description);
        text.setAttribute('color', this.textColor);
        text.setAttribute('font-size', '0.022');
        text.setAttribute('line-height', '1.2');
        text.setAttribute('anchor', 'left');
        text.setAttribute('baseline', 'top');
        text.setAttribute('max-width', '0.90');
        text.setAttribute('depth-offset', '-10');
        text.setAttribute('position', '-0.45 0.15 0.01');
        tooltip.appendChild(text);

        this.el.appendChild(tooltip);
        this._articleTooltip = tooltip;
    },

    _hideArticleTooltip: function() {
        if (this._articleTooltip) {
            this._articleTooltip.remove();
            this._articleTooltip = null;
        }
    }
});

export function mountSourcesPanel() {
    const leftPanel2 = document.querySelector('#left-panel-2');
    if (!leftPanel2) return;

    let sourcesTab = leftPanel2.querySelector('#news-graph-sources-vr');
    if (!sourcesTab) {
        sourcesTab = document.createElement('a-entity');
        sourcesTab.setAttribute('id', 'news-graph-sources-vr');
        
        sourcesTab.setAttribute('scale', '1 1 1');
        sourcesTab.setAttribute('position', '0 6 0'); 

        sourcesTab.setAttribute('news-graph-sources-vr', '');
        sourcesTab.setAttribute('visible', 'false');
        leftPanel2.appendChild(sourcesTab);
    } else {
        sourcesTab.setAttribute('visible', 'false');
        sourcesTab.setAttribute('position', '0 6 0');
    }
}
